import { render, staticRenderFns } from "./addCostFee.vue?vue&type=template&id=cd4794cc&scoped=true&"
import script from "./addCostFee.vue?vue&type=script&lang=js&"
export * from "./addCostFee.vue?vue&type=script&lang=js&"
import style0 from "./addCostFee.vue?vue&type=style&index=0&id=cd4794cc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd4794cc",
  null
  
)

export default component.exports